module.exports = __webpack_public_path__ + "img/bg-image-1.4805dbea.jpg";